export default __webpack_public_path__ + "static/media/I-2018.87792ad3.pdf";